import React, {Component} from 'react';

export default class DashboardDetail extends Component {

    render() {
        const value = this.props.orders[this.props.el];
        const displayValue = (value === 'null' || value === null || value === undefined || value === '') ? 'Yok' : value;

        return (
            <li className="dashboard-detail-list">
                <span>
                    <strong>{this.props.label}</strong>
                    <small>{displayValue}</small>
                </span>
            </li>
        );
    }
}
